import React from 'react';

// FIGMA: https://www.figma.com/file/isI24MS5FurNhkXfDybGSc/Fibe---Web-Handover?node-id=12066-205146&t=M9CY9w5lkU54PMjR-0

import circleRightIcon from '../../../assets/nach-cancellation/circleRightIcon.svg';

const SingleMandateCard = ({ singleMandateData }) => {
  const { accountNo, amount, bankName, name } = singleMandateData;
  return (
    <>
      {/* SingleMandateCard */}
      {/* <div className="grid gap-7 grid-cols-1 grid-rows-1 lg:grid-cols-2 lg:grid-rows-2 p-4 lg:p-0"> */}
      <div className="rounded-2xl border border-stroke bg-white flex flex-col justify-end">
        {/* <div className="flex justify-end mt-3">
          <div className="bg-accent text-white text-[12px] rounded-l-[50px] flex items-center w-auto pt-[2px] pb-[2px] pl-1">
            <img src={circleRightIcon} alt="circleRightIcon" />
            <span className="block ml-1 pr-3">Primary</span>
          </div>
        </div> */}

        <div className="grid grid-cols-2 lg:grid-cols-1 justify-between">
          <div className="flex items-center justify-start lg:justify-between flex-col lg:flex-row text-sm lg:text-lg  px-3 pt-4 pb-2">
            <div className="text-text-secondary w-full">Account name</div>
            <div className="text-text-primary text-left lg:text-right w-full">
              {name}
            </div>
          </div>

          <div className="flex items-center justify-start lg:justify-between flex-col lg:flex-row text-sm lg:text-lg  px-3 pt-4 pb-2">
            <div className="text-text-secondary w-full">Account number</div>
            <div className="text-text-primary text-left lg:text-right w-full">
              {accountNo}
            </div>
          </div>

          <div className="flex items-center justify-start lg:justify-between flex-col lg:flex-row text-sm lg:text-lg  px-3 pt-4 pb-2">
            <div className="text-text-secondary w-full">Bank name</div>
            <div className="text-text-primary text-left lg:text-right w-full">
              {bankName}
            </div>
          </div>

          <div className="flex items-center justify-start lg:justify-between flex-col lg:flex-row text-sm lg:text-lg  px-3 pt-4 pb-4">
            <div className="text-text-secondary w-full">Amount</div>
            <div className="text-text-primary text-left lg:text-right w-full">
              {amount.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR',
              })}
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default SingleMandateCard;
